"use client";

/**
 * KnowledgeWarmup — renders nothing; mounts the queries behind the Knowledge
 * root (files listing, creations, media) at app-shell level so they are cached
 * before the user ever clicks Knowledge. Combined with the root snapshot this
 * kills the open staircase (founder 08-03): by the time the page mounts, React
 * Query serves warm data in the first frame and only revalidates in the
 * background. All payloads are small and power a primary surface; the
 * socket-driven invalidation they already carry keeps them fresh for the whole
 * session.
 */

import { useFilesListing } from "@/components/files-browser/queries";
import { useUserArtifacts } from "@/components/studio-canvas/queries";
import { useMediaArtifacts } from "@/components/media-library/queries";
import { useBrainTree } from "@/components/brain/queries";
import { useMemoryProfile } from "@/components/memory/queries";

export function KnowledgeWarmup(): null {
  useFilesListing();
  useUserArtifacts();
  useMediaArtifacts();
  // The brain LISTING, so the Brain room's front door is painted from cache
  // rather than fetched on the click. It is the one read every section of that
  // room makes, and the expensive one.
  //
  // AND NOT THE MAP. `knowledge/index.md` was warmed beside it because the room
  // used to OPEN on the compiled map; since D6 it opens on Home, and no screen
  // there reads the map at all — so that read was a request per app load, for
  // every user, for a page nobody was about to see.
  //
  // A WARMUP IS NEVER A WAKE (Ruling 247): this read prefers the published head
  // and falls through to the live volume only when the head cannot answer,
  // which is the same read the room itself makes a moment later.
  useBrainTree();
  useMemoryProfile();
  return null;
}
